import styles from './ControlPanelHeader.module.scss';

const ControlPanelHeader = ({ tab }: { tab?: string }) => (
  <div className={styles.container}>
    <div className={styles.title}>Control Panel</div>
  </div>
);

export default ControlPanelHeader;
